/* HIPHOT Quote Chat (Sunny) — Shopify build
 *
 * Forked from the WordPress plugin v1.3.3 script.js.
 * - No jQuery, no WP AJAX.
 * - System prompt and welcome message come from /api/config?lang=...
 * - Conversation logging goes to /api/save-conversation (Supabase).
 * - Completed leads POST to the 48-7 CRM (primary) with /api/send-emails as fallback.
 *
 * All wiring is read from data-* attributes on #hiphotAdvisorRoot.
 */
(function () {
  'use strict';

  // ── UI strings per language ────────────────────────────────────────────────
  const UI = {
    nl: {
      sendLabel: 'Verstuur',
      placeholder: 'Typ je antwoord...',
      intro: 'Oh ja, ik vergeet mezelf helemaal voor te stellen — ik ben Sunny! 😄\nMet wie ben ik aan het chatten?',
      configError: 'Sorry, de configuratie kon niet geladen worden. Neem contact op met de beheerder.',
      networkError: 'Sorry, er ging iets mis. Probeer het opnieuw.',
      phoneInvalid: 'Oeps! Het lijkt erop dat het telefoonnummer niet klopt. Kun je het nog een keer proberen?',
      retryHint: 'Even druk, ik wacht ',
      sunnyLabel: 'Sunny',
      userLabel: 'Jij',
    },
    de: {
      sendLabel: 'Senden',
      placeholder: 'Antwort eingeben...',
      intro: 'Willkommen, ich helfe Ihnen gern bei einer passenden HIPHOT-Lösung.\nFür welchen Standort oder welche Organisation möchten Sie ein Angebot anfordern?',
      configError: 'Entschuldigung, die Konfiguration konnte nicht geladen werden. Bitte wenden Sie sich an den Administrator.',
      networkError: 'Entschuldigung, etwas ist schiefgegangen. Bitte versuchen Sie es erneut.',
      phoneInvalid: 'Hoppla! Die Telefonnummer scheint nicht zu stimmen. Können Sie es bitte noch einmal versuchen?',
      retryHint: 'Kurz Geduld, ich warte ',
      sunnyLabel: 'Sunny',
      userLabel: 'Sie',
    },
    en: {
      sendLabel: 'Send',
      placeholder: 'Type your answer...',
      intro: 'Oh, I should introduce myself — I’m Sunny! 😄\nWho am I chatting with?',
      configError: 'Sorry, the configuration could not be loaded. Please contact the administrator.',
      networkError: 'Sorry, something went wrong. Please try again.',
      phoneInvalid: 'Oops! That phone number doesn’t look right. Could you try again?',
      retryHint: 'A bit busy, waiting ',
      sunnyLabel: 'Sunny',
      userLabel: 'You',
    },
  };

  // ── Bootstrap: read config from #hiphotAdvisorRoot ─────────────────────────
  const root = document.getElementById('hiphotAdvisorRoot');
  if (!root) return;

  // Clientside ?lang=de|en|nl override (for theme previews where Shopify
  // serves a cached Liquid page — the data-lang attribute is then stale).
  // Ignored if not one of the supported languages.
  const SUPPORTED_LANGS = ['nl', 'de', 'en'];
  let _langOverride = null;
  try {
    const q = (new URL(window.location.href).searchParams.get('lang') || '').toLowerCase();
    if (SUPPORTED_LANGS.indexOf(q) !== -1) _langOverride = q;
  } catch (e) { /* ignore */ }
  const _dataLang = (root.dataset.lang || 'en').toLowerCase();
  const LANG = _langOverride || (SUPPORTED_LANGS.indexOf(_dataLang) !== -1 ? _dataLang : 'en');
  const SOURCE = root.dataset.source || 'shopify_eu';
  console.log('[Quote Chat] init — LANG=' + LANG + ', source=' + SOURCE + (_langOverride ? ' (override via ?lang)' : ''));
  const API_BASE = root.dataset.apiBase || 'https://hh-offerte-chat-nl.vercel.app/api';
  const CRM_ENDPOINT = root.dataset.crmEndpoint || 'https://crm.48-7.nl/api/public/chatbot-intake';
  const CRM_TENANT = root.dataset.crmTenant || 'hiphot';
  const AVATAR_URL = root.dataset.avatarUrl || '';
  const STRINGS = UI[LANG] || UI.en;

  // ── State ──────────────────────────────────────────────────────────────────
  let SYSTEM_PROMPT = '';
  let WELCOME_MESSAGE = '';
  let PHONE_PATTERN = null; // RegExp or null
  let conversationHistory = [{ role: 'user', content: 'Start the advisory conversation' }];
  let conversationId = null;
  let hasIntroduced = true;
  let isWaitingForPhone = false;
  let __completionFired = false;

  // ── DOM helpers ────────────────────────────────────────────────────────────
  const $ = (id) => document.getElementById(id);
  const chatContainer = $('hiphotChatContainer');
  const typingIndicator = $('hiphotTypingIndicator');
  const userInput = $('hiphotUserInput');
  const sendButton = $('hiphotSendButton');
  const sendText = $('hiphotSendText');

  function showTyping() {
    if (typingIndicator) typingIndicator.classList.add('active');
    if (chatContainer) chatContainer.scrollTop = chatContainer.scrollHeight;
  }
  function hideTyping() {
    if (typingIndicator) typingIndicator.classList.remove('active');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function basicMarkdown(text) {
    let html = escapeHtml(text);
    html = html.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/(^|\n)-\s+([^\n]+)/g, '$1<li>$2</li>');
    html = html.replace(/(<li>[\s\S]*?<\/li>)(?!\s*<li>)/g, '<ul>$1</ul>');
    html = html.replace(/\n/g, '<br>');
    html = html.replace(/<\/ul><br>/g, '</ul>').replace(/<br><ul/g, '<ul');
    return html;
  }

  function addMessage(text, sender) {
    if (!chatContainer) return;
    const messageDiv = document.createElement('div');
    messageDiv.className = `hiphot-message ${sender}`;
    if (sender === 'ai' && AVATAR_URL) {
      const avatar = document.createElement('img');
      avatar.src = AVATAR_URL;
      avatar.alt = STRINGS.sunnyLabel;
      avatar.className = 'hiphot-avatar';
      messageDiv.appendChild(avatar);
    }
    const contentDiv = document.createElement('div');
    contentDiv.className = 'hiphot-message-content';
    const displayText = String(text || '').replace(/```json[\s\S]*?```/g, '').trim();
    if (sender === 'ai') {
      contentDiv.innerHTML = basicMarkdown(displayText);
    } else {
      contentDiv.textContent = displayText;
    }
    messageDiv.appendChild(contentDiv);
    chatContainer.appendChild(messageDiv);
    chatContainer.scrollTop = chatContainer.scrollHeight;
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  async function init() {
    if (sendText) sendText.textContent = STRINGS.sendLabel;
    if (userInput) userInput.placeholder = STRINGS.placeholder;
    if (sendButton) sendButton.setAttribute('aria-label', STRINGS.sendLabel);

    sendButton && sendButton.addEventListener('click', sendMessage);
    userInput && userInput.addEventListener('keypress', (e) => {
      if (e.key === 'Enter') sendMessage();
    });

    try {
      const r = await fetch(`${API_BASE}/config?lang=${encodeURIComponent(LANG)}`);
      if (!r.ok) throw new Error(`config ${r.status}`);
      const cfg = await r.json();
      SYSTEM_PROMPT = cfg.system_prompt || '';
      WELCOME_MESSAGE = cfg.welcome_message || '';
      if (cfg.phone_pattern) {
        try { PHONE_PATTERN = new RegExp(cfg.phone_pattern); } catch (e) { PHONE_PATTERN = null; }
      }
    } catch (e) {
      console.error('[Quote Chat] config load failed:', e);
      setTimeout(() => addMessage(STRINGS.configError, 'ai'), 600);
      return;
    }

    // Seed conversation with welcome (so the LLM sees the same context the user did)
    conversationHistory.push({ role: 'assistant', content: WELCOME_MESSAGE });

    setTimeout(() => addMessage(WELCOME_MESSAGE, 'ai'), 800);
  }

  // ── Phone validation ───────────────────────────────────────────────────────
  function isAcceptablePhone(message) {
    const digits = message.replace(/\D/g, '');
    if (PHONE_PATTERN) {
      return PHONE_PATTERN.test(message) || PHONE_PATTERN.test(digits);
    }
    // Lenient default: 7–15 digits, allow + and spaces in display
    return digits.length >= 7 && digits.length <= 15;
  }

  function looksLikePhoneAttempt(message) {
    const digits = message.replace(/\D/g, '');
    return digits.length >= 4 && !/[@.]/.test(message);
  }

  // ── Sending ────────────────────────────────────────────────────────────────
  async function sendMessage() {
    if (!userInput) return;
    const message = userInput.value.trim();
    if (!message) return;

    if (isWaitingForPhone && looksLikePhoneAttempt(message)) {
      if (!isAcceptablePhone(message)) {
        addMessage(message, 'user');
        userInput.value = '';
        setTimeout(() => addMessage(STRINGS.phoneInvalid, 'ai'), 500);
        return;
      }
      isWaitingForPhone = false;
    }

    addMessage(message, 'user');
    userInput.value = '';
    conversationHistory.push({ role: 'user', content: message });

    saveIncomplete();

    if (!hasIntroduced) {
      hasIntroduced = true;
      setTimeout(() => {
        addMessage(STRINGS.intro, 'ai');
        conversationHistory.push({ role: 'assistant', content: STRINGS.intro });
      }, 1000);
      return;
    }

    showTyping();
    if (sendButton) sendButton.disabled = true;

    try {
      let response, data;
      const retryDelays = [15000, 30000, 45000];
      for (let attempt = 0; attempt <= retryDelays.length; attempt++) {
        response = await fetch(`${API_BASE}/test?action=chat`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            model: 'claude-sonnet-4-6',
            max_tokens: 2048,
            system: SYSTEM_PROMPT,
            messages: conversationHistory,
          }),
        });
        if (response.status === 429 && attempt < retryDelays.length) {
          console.log(`${STRINGS.retryHint}${retryDelays[attempt] / 1000}s...`);
          await new Promise((res) => setTimeout(res, retryDelays[attempt]));
          continue;
        }
        break;
      }

      data = await response.json();
      hideTyping();
      if (sendButton) sendButton.disabled = false;

      if (data && data.content && data.content[0]) {
        const aiMessage = data.content[0].text;
        addMessage(aiMessage, 'ai');
        conversationHistory.push({ role: 'assistant', content: aiMessage });

        const lower = aiMessage.toLowerCase();
        if (
          lower.includes('telefoonnummer') ||
          lower.includes('telefoon') ||
          lower.includes('telefon') ||
          lower.includes('phone')
        ) {
          isWaitingForPhone = true;
        }

        processAiMessageForCompletion(aiMessage);
      }
    } catch (error) {
      hideTyping();
      if (sendButton) sendButton.disabled = false;
      console.error('[Quote Chat] chat error:', error);
      addMessage(STRINGS.networkError, 'ai');
    }
  }

  // ── Completion detection ──────────────────────────────────────────────────
  function isCompletionSignal(aiText) {
    if (!aiText) return false;
    const t = aiText.toLowerCase();
    if (t.indexOf('[offerte_compleet]') !== -1) return true;
    const handoffPhrases = LANG === 'de'
      ? ['hiphot-mitarbeiter', 'mitarbeiter von hiphot', 'maßgeschneidertes angebot', 'angebot zukommen', 'meldet sich in kürze']
      : LANG === 'en'
      ? ['hiphot colleague', 'a hiphot team member', 'tailored quote', 'will be in touch']
      : ['medewerker van hiphot', 'iemand van hiphot', 'collega van hiphot', 'offerte op maat', 'offerte op je toesturen', 'offerte naar je toesturen', 'neemt zo snel mogelijk contact'];
    for (let i = 0; i < handoffPhrases.length; i++) {
      if (t.indexOf(handoffPhrases[i]) !== -1) return true;
    }
    return false;
  }

  function buildAdviceDataFromHistory() {
    const userMessages = conversationHistory
      .filter((m) => m.role === 'user')
      .map((m) => m.content);
    const allUserText = userMessages.join('\n');

    const emailMatch = allUserText.match(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/);
    const email = emailMatch ? emailMatch[0] : '';

    let telefoon = '';
    for (let j = 0; j < userMessages.length; j++) {
      if (isAcceptablePhone(userMessages[j])) {
        telefoon = userMessages[j].trim();
        break;
      }
    }

    let naam = '';
    for (let k = 0; k < conversationHistory.length - 1; k++) {
      const m = conversationHistory[k];
      if (
        m.role === 'assistant' &&
        /met wie ben ik aan het chatten|mit wem habe ich|who am i chatting with/i.test(m.content)
      ) {
        const next = conversationHistory[k + 1];
        if (next && next.role === 'user') {
          naam = next.content
            .replace(/^(ik ben|ik heet|mijn naam is|ich bin|ich heiße|mein name ist|i am|i'm|my name is)\s+/i, '')
            .split(/[\n,.!?]/)[0]
            .trim();
        }
        break;
      }
    }

    let bedrijf = '';
    for (let l = 0; l < conversationHistory.length - 1; l++) {
      const msg = conversationHistory[l];
      if (
        msg.role === 'assistant' &&
        /bedrijfsnaam|naam van (?:je|jullie|de) (?:bedrijf|organisatie)|firmenname|name (?:ihres|deines) unternehmens|company name|name of your (?:company|organisation|organization)/i.test(
          msg.content,
        )
      ) {
        const nxt = conversationHistory[l + 1];
        if (nxt && nxt.role === 'user') {
          bedrijf = nxt.content.split(/[\n,]/)[0].trim();
        }
        break;
      }
    }

    const branche = (userMessages[1] || '').split(/[\n,.!?]/)[0].trim();
    const tbd = LANG === 'de'
      ? 'Wird vom HIPHOT-Team bestimmt'
      : LANG === 'en'
      ? 'To be determined by HIPHOT team'
      : 'Nog te bepalen door HIPHOT team';

    return {
      klant: { naam, bedrijf, email, telefoon },
      situatie: {
        branche,
        aantal_medewerkers: 0,
        binnen_buiten: '',
        schaduw: '',
        plaatsing: '',
        ondergrond: '',
        custom_design: '',
        opmerkingen: 'Derived from chat history — AI did not emit a JSON block.',
      },
      advies: {
        spf: tbd,
        aantal_dispensers: tbd,
        formaat: tbd,
        accessoires: [tbd],
        geschat_jaarverbruik: tbd,
        rationale: tbd,
      },
    };
  }

  function processAiMessageForCompletion(aiMessage) {
    if (__completionFired) return;

    const jsonMatch = aiMessage.match(/```json\n([\s\S]*?)\n```/);
    if (jsonMatch) {
      try {
        const adviceData = JSON.parse(jsonMatch[1]);
        finalize(adviceData, 'json-block');
        return;
      } catch (e) {
        console.warn('[Quote Chat] JSON block parse failed; falling back to heuristic.', e);
      }
    }

    if (!isCompletionSignal(aiMessage)) return;

    const derived = buildAdviceDataFromHistory();
    const k = derived.klant || {};
    if (!k.email || !k.telefoon) {
      console.log('[Quote Chat] Completion fingerprint, but email/phone missing; skipping fire.', {
        email: !!k.email,
        telefoon: !!k.telefoon,
      });
      return;
    }
    finalize(derived, 'heuristic');
  }

  function finalize(adviceData, via) {
    if (__completionFired) return;
    __completionFired = true;

    if (userInput) userInput.disabled = true;
    if (sendButton) sendButton.disabled = true;

    console.log(`[Quote Chat] Completion via "${via}". Firing CRM + DB save.`);

    postToCRM(adviceData).then((ok) => {
      if (ok) {
        console.log('[Quote Chat] CRM intake OK');
      } else {
        console.log('[Quote Chat] CRM failed → fallback email');
        sendEmailFallback(adviceData);
      }
    });

    saveComplete(adviceData);
  }

  // ── Server interactions ──────────────────────────────────────────────────
  async function saveIncomplete() {
    if (conversationHistory.length < 3) return;
    try {
      const r = await fetch(`${API_BASE}/save-conversation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: conversationId || undefined,
          lang: LANG,
          source: SOURCE,
          is_complete: false,
          chat_history: conversationHistory,
        }),
      });
      const j = await r.json();
      if (j && j.id) conversationId = j.id;
    } catch (e) {
      console.error('[Quote Chat] save incomplete failed:', e);
    }
  }

  async function saveComplete(data) {
    try {
      const r = await fetch(`${API_BASE}/save-conversation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: conversationId || undefined,
          lang: LANG,
          source: SOURCE,
          is_complete: true,
          chat_history: conversationHistory,
          data,
        }),
      });
      const j = await r.json();
      if (j && j.id) {
        conversationId = j.id;
        console.log('[Quote Chat] Saved complete, id=', conversationId);
      }
    } catch (e) {
      console.error('[Quote Chat] save complete failed:', e);
    }
  }

  async function postToCRM(advice) {
    try {
      const k = advice.klant || {};
      const s = advice.situatie || {};
      const a = advice.advies || {};
      if (!k.naam || !k.email) {
        console.error('[Quote Chat] CRM POST: missing required (naam/email)');
        return false;
      }

      const transcript = conversationHistory
        .map((msg) => `${msg.role === 'user' ? 'KLANT' : 'AI'}: ${msg.content}`)
        .join('\n');

      const payload = {
        tenant: CRM_TENANT,
        source: `chatbot_${LANG}`,
        source_url: window.location.href,
        klant: {
          naam: k.naam || '',
          bedrijf: k.bedrijf || '',
          email: k.email || '',
          telefoon: k.telefoon || '',
        },
        situatie: {
          branche: s.branche || '',
          aantal_medewerkers: s.aantal_medewerkers !== undefined ? s.aantal_medewerkers : null,
          binnen_buiten: s.binnen_buiten || '',
          schaduw: s.schaduw || '',
          plaatsing: s.plaatsing || '',
          ondergrond: s.ondergrond || '',
          custom_design: s.custom_design || '',
          opmerkingen: s.opmerkingen || '',
        },
        advies: {
          spf: a.spf || '',
          aantal_dispensers: a.aantal_dispensers || '',
          formaat: a.formaat || '',
          accessoires: Array.isArray(a.accessoires) ? a.accessoires : [],
          geschat_jaarverbruik: a.geschat_jaarverbruik || '',
          rationale: a.rationale || '',
        },
        openstaande_vragen: [],
        transcript,
      };

      const controller = new AbortController();
      const t = setTimeout(() => controller.abort(), 10000);
      const r = await fetch(CRM_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        signal: controller.signal,
      });
      clearTimeout(t);
      return r.ok;
    } catch (e) {
      console.error('[Quote Chat] CRM POST error:', e.name === 'AbortError' ? 'timeout' : e.message);
      return false;
    }
  }

  async function sendEmailFallback(advice) {
    try {
      const r = await fetch(`${API_BASE}/send-emails`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ lang: LANG, conversation: advice }),
      });
      const j = await r.json();
      console.log('[Quote Chat] email fallback result:', j && j.success ? 'sent' : 'failed', j);
    } catch (e) {
      console.error('[Quote Chat] email fallback error:', e);
    }
  }

  // ── Go ────────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
